
import { Injectable } from '@angular/core';
import { ICarouselDate } from '../interfaces/carousel.interface';
import { TokenStorageService } from 'apps/cambix/src/utils/services/token/token.storage.service';
import { Observable, of } from 'rxjs';

type MenuOptions = {
  code: number,
  name: string,
  icon: string,
  iconActive: string,
  active: false,
  routerlink: string,
}

type CxAccount = {
  account: string,
  currencyCode: string
};

type CxAccountData = {
  code: string,
  name: string,
  account: CxAccount[]
};

@Injectable({
  providedIn: 'root',
})
export class GlobalService {

  sesionUsuario: any;
  banksWithCambixAccounts: CxAccountData[] = [
    {
        code: '009',
        name: 'BANCO SCOTIABANK',
        account: [
            {
                account: '3678991',
                currencyCode: 'PEN'
            },
            {
                account: '5229844',
                currencyCode: 'USD'
            }
        ]
    },
    {
        code: '002',
        name: 'BANCO DE CREDITO',
        account: [
            {
                account: '1911454937031',
                currencyCode: 'PEN'
            },
            {
                account: '1911454938151',
                currencyCode: 'USD'
            }
        ]
    },
    {
        code: '023',
        name: 'Bancom',
        account: [
            {
                account: '419400787105',
                currencyCode: 'PEN'
            },
            {
                account: '419400787090',
                currencyCode: 'USD'
            }
        ]
    },
    {
        code: '035',
        name: 'Pichincha',
        account: [
            {
                account: '001586052896',
                currencyCode: 'PEN'
            },
            {
                account: '001586052934 ',
                currencyCode: 'USD'
            }
        ]
    },
    {
        code: '011',
        name: 'BANCO CONTINENTAL',
        account: [
            {
                account: '00110708550100002883',
                currencyCode: 'PEN'
            },
            {
                account: '00110708580100002891',
                currencyCode: 'USD'
            }
        ]
    },
    {
        code: '003',
        name: 'BANCO INTERBANK',
        account: [
            {
                account: '2003005870320',
                currencyCode: 'PEN'
            },
            {
                account: '2003005870337',
                currencyCode: 'USD'
            }
        ]
    }
  ];

  //MENUS
  private personMenuOptions: MenuOptions[] = [
    {
      code: 1,
      name: 'Inicio',
      icon: 'assets/imagenes/iconos/icono-hogar-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-hogar-azul.svg',
      active: false,
      routerlink: 'cambix/dashboard/home',
    },
    {
      code: 2,
      name: 'Cambiar dólares',
      icon: './assets/imagenes/iconos/icono-cambiar-dolares-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-cambiar-dolares-azul.svg',
      active: false,
      routerlink: 'cambix/dashboard/change-dollar',
    },
    {
      code: 3,
      name: 'Mis Operaciones',
      icon: 'assets/imagenes/iconos/icono-operaciones-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-operaciones-azul.svg',
      active: false,
      routerlink: 'cambix/dashboard/operations',
    },
    {
      code: 4,
      name: 'Empresa',
      icon: 'assets/dashboard-business/iconos/icono-menu-business-blanco.svg',
      iconActive:
        'assets/dashboard-business/iconos/icono-menu-business-azul.svg',
      active: false,
      routerlink: 'Empresa',
    },
  ];
  private businessMenuOptions: MenuOptions[] = [
    {
      code: 1,
      name: 'Inicio',
      icon: 'assets/imagenes/iconos/icono-hogar-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-hogar-azul.svg',
      active: false,
      routerlink: 'cambix-business/dashboard/home',
    },
    {
      code: 2,
      name: 'Cambiar dólares',
      icon: './assets/imagenes/iconos/icono-cambiar-dolares-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-cambiar-dolares-azul.svg',
      active: false,
      routerlink: 'cambix-business/dashboard/change-dolar',
    },
    {
      code: 3,
      name: 'Mis Operaciones',
      icon: 'assets/imagenes/iconos/icono-operaciones-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-operaciones-azul.svg',
      active: false,
      routerlink: 'cambix-business/dashboard/my-operations',
    },
  ];
  private personBusinessMenuOptions: MenuOptions[] = [
    {
      code: 1,
      name: 'Inicio',
      icon: 'assets/imagenes/iconos/icono-hogar-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-hogar-azul.svg',
      active: false,
      routerlink: 'cambix-business/dashboard/home',
    },
    {
      code: 2,
      name: 'Cambiar dólares',
      icon: './assets/imagenes/iconos/icono-cambiar-dolares-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-cambiar-dolares-azul.svg',
      active: false,
      routerlink: 'cambix-business/dashboard/change-dolar',
    },
    {
      code: 3,
      name: 'Mis Operaciones',
      icon: 'assets/imagenes/iconos/icono-operaciones-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-operaciones-azul.svg',
      active: false,
      routerlink: 'cambix-business/dashboard/my-operations',
    },
    {
      code: 4,
      name: 'Persona',
      icon: 'assets/dashboard-business/iconos/icono-menu-persona-blanco.svg',
      iconActive:
        'assets/dashboard-business/iconos/icono-menu-persona-azul.svg',
      active: false,
      routerlink: 'Empresa',
    },
  ];


  //TOOLBAR
  private personToolBarOptions: MenuOptions[] = [
    {
      code: 0,
      name: 'Empresa',
      icon: 'assets/imagenes/iconos/icono-operaciones-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-operaciones-azul.svg',
      active: false,
      routerlink: 'Empresa',
    }
  ];

  private personBusinessToolBarOptions: MenuOptions[] = [
    {
      code: 0,
      name: 'Persona',
      icon: 'assets/imagenes/iconos/icono-operaciones-blanco.svg',
      iconActive: 'assets/imagenes/iconos/icono-operaciones-azul.svg',
      active: false,
      routerlink: 'Persona',
    }
  ];

  constructor(
    private tokenStorageService: TokenStorageService
  ) {
    const datosSession : any = this.tokenStorageService.getStoreSessionUser();
    this.sesionUsuario = JSON.parse(datosSession);
  }


  onCopyCodeText(text: any) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log('Código copiado');
      })
      .catch((err) => {
        console.error('Error al copiar el código:', err);
      });
  }

  getDatos() {
    return [
      {
        tipoCliente: 'Para clientes Bancom',
        FechahorarioCliente: 'Lun. a  Dom.',
        HoraAtencionCliente: '8:00 a.m. - 11:45 p.m.',
      },
      {
        tipoCliente: 'Horario de atención',
        FechahorarioCliente: 'Lun. a  Dom.',
        HoraAtencionCliente: '8:00am - 6:00pm',
      },
    ];
  }

  getSteppers() {
    return [
      {
        titulo: 'Registrar operación',
        subtitulo: 'Ingresa los datos que te pedimos.',
        estado: '',
      },
      {
        titulo: 'Transfiere',
        subtitulo: 'Realiza una transferencia inmediata.',
        estado: '',
      },
      {
        titulo: 'Revisa detalles de operación',
        subtitulo: 'Revisa los datos.',
        estado: '',
      },
    ];
  }

  getSteppersBusiness() {
    return [
      {
        titulo: 'Registrar operación',
        subtitulo: 'Ingresa los datos que te pedimos.',
        estado: '',
      },
      {
        titulo: 'Transfiere',
        subtitulo:  'Realiza la transferencia que te indicamos.',
        estado: '',
      },
      {
        titulo: 'Revisa detalles de operación',
        subtitulo: 'Revisa los datos.',
        estado: '',
      },
    ];
  }


  getImgBancos() {
    return [
      {
        imagenBanco: 'assets/imagenes/bancos/banco-bcp.svg',
        alt: 'Logo de banco BCP Cambix tipo de cambio compra y venta dólar',
      },
      {
        imagenBanco: 'assets/imagenes/bancos/banco-ibk.svg',
        alt: 'Logo de banco IBK Cambix tipo de cambio compra y venta dólar',
      },
      {
        imagenBanco: 'assets/imagenes/bancos/banco-scotiabank.svg',
        alt: 'Logo de banco SCOTIBANK Cambix tipo de cambio compra y venta dólar',
      },
      {
        imagenBanco: 'assets/imagenes/bancos/banco-pichincha.svg',
        alt: 'Logo de banco PICHINCHA Cambix tipo de cambio compra y venta dólar',
      },
      {
        imagenBanco: 'assets/imagenes/bancos/banco-banbif.svg',
        alt: 'Logo de banco BANBIF Cambix tipo de cambio compra y venta dólar',
      },
    ];
  }

  getNombreMasBancos() {
    return [
      { nombreBanco: 'Banco Falabella' },
      { nombreBanco: 'Banco de la Nación' },
      { nombreBanco: 'Banco Financiero' },
      { nombreBanco: 'Banco GNB' },
      { nombreBanco: 'Citibank' },
      { nombreBanco: 'Mibanco' },
      { nombreBanco: 'Crediscotia' },
      { nombreBanco: 'Caja Cuzco' },
      { nombreBanco: 'Caja Arequipa' },
      { nombreBanco: 'Caja Piura' },
      { nombreBanco: 'Caja Sullana' },
      { nombreBanco: 'Caja Trujillo' },
      { nombreBanco: 'Caja Ica' },
    ];
  }

  getAccionesBoton() {
    return [
      {
        imgurl:
          'data:image/png;base64,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',
        nombreAccion: 'Editar',
        accion: 'Editar',
      },
      {
        imgurl:
          'data:image/png;base64,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',
        nombreAccion: 'Borrar',
        accion: 'Borrar',
      },
      {
        imgurl:
          'https://previews.123rf.com/images/blankstock/blankstock1802/blankstock180200066/95164344-cambio-de-moneda-simple-icono-muestra-de-transferencia-de-dinero-d%C3%B3lar-en-s%C3%ADmbolo-de-flecha-de.jpg',
        nombreAccion: 'Imprimir',
        accion: 'Imprimir',
      },
    ];
  }

  getMenu(selectedProfile: string): Observable<MenuOptions[]> {
    const datosSession : any = this.tokenStorageService.getStoreSessionUser();
    this.sesionUsuario = JSON.parse(datosSession);

    const { userType, hasUser } = this.sesionUsuario;
    let menuOptions: Observable<MenuOptions[]> = of(this.personMenuOptions);

    if(selectedProfile === 'EMP') {
      if (userType === 'EMP' && hasUser === false) {
        menuOptions = of(this.businessMenuOptions);
      }

      if (userType === 'EMP' && hasUser === true) {
        menuOptions = of(this.personBusinessMenuOptions);
      }
    }

    return menuOptions;
  }


  getToolBar(selectedProfile: string): Observable<MenuOptions[]> {
    const datosSession : any = this.tokenStorageService.getStoreSessionUser();
    this.sesionUsuario = JSON.parse(datosSession);

    const { userType, hasUser } = this.sesionUsuario;
    let toolbarOptions: Observable<MenuOptions[]> = of(this.personToolBarOptions);

    if(selectedProfile === 'EMP') {
      if (userType === 'EMP' && hasUser === false) {
        toolbarOptions = of([]);
      }

      if (userType === 'EMP' && hasUser === true) {
        toolbarOptions = of(this.personBusinessToolBarOptions);
      }
    }

    return toolbarOptions;
  }

  getDatosMenu() {
    return this.personMenuOptions;
  }

  getDatosMenuBusiness() {

    const { hasUser } = this.sesionUsuario;

    if (hasUser === false) {
      return this.businessMenuOptions
    }

    return this.personBusinessMenuOptions;
  }


  getItemSwitch() {
    return [
      {
        name: 'Compra',
        status: Boolean,
      },
      {
        name: 'Venta',
        status: Boolean,
      },
    ];
  }

  getDataCarousel(): ICarouselDate[] {
    return [
      {
        image: {
          urlWebImage:
            './assets/imagenes/banners/banner-rentabiliza-dolares-web.png',
          urlAppImage:
            './assets/imagenes/banners/banner-rentabiliza-dolares-app.png',
        },
        product: {
          url: 'https://www.bancom.pe/forms/dpf-dolares',
          content: 'Conocer mas',
        },
      },
      {
        image: {
          urlWebImage:
            './assets/imagenes/banners/banner-prestamo-rapido-web.png',
          urlAppImage:
            './assets/imagenes/banners/banner-prestamo-rapido-app.png',
        },
        product: {
          url: 'https://prestamodigital.bancom.pe/',
          content: 'Conocer mas',
        },
      },
      {
        image: {
          urlWebImage:
            './assets/imagenes/banners/banner-rentabiliza-dolares-web.png',
          urlAppImage:
            './assets/imagenes/banners/banner-rentabiliza-dolares-app.png',
        },
        product: {
          url: 'https://cuentadigital.bancom.pe/producto/cuenta-ahorro',
          content: 'Conocer mas',
        },
      },
    ];
  }

  hasAccount(accountNumber: string): boolean {
    const BANK_CODE = accountNumber.substring(0, 3);

    return this.banksWithCambixAccounts.findIndex((account) => account.code === BANK_CODE) >= 0 ? true : false;
  }

  getCambixAccount(bankCode: string): CxAccountData | undefined {
    return this.banksWithCambixAccounts.find((account) => account.code === bankCode);
  }
}
